<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    props: {},
    data() {
        return {};
    },
    methods: {
        Fun() {
            var screenWidth = document.body.clientWidth;
            var route = this.$route;
            var path = JSON.parse(JSON.stringify(this.$route.path));
            if (screenWidth <= 800) {
                path = path.replace("pc", "mobile");
                if (this.$route.path != path) {
                    this.$router.replace({ path: path, query: route.query });
                }
            } else {
                path = path.replace("mobile", "pc");
                if (this.$route.path != path) {
                    this.$router.replace({ path: path, query: route.query });
                }
            }
        },
    },
    computed: {},
    created() {},
    mounted() {
        const that = this;
        window.onresize = () => {
            return (() => {
              this.Fun()
            })();
        };
    },
};
</script>
<style>
html {
    overflow-y: scroll;
}
#app {
    /* display: flex;
  justify-content: center;
  width: calc(100% - 8px);
  min-height: 100vh; */
}
@font-face {
    font-family: KhmerSangamMN;
    src: url("./assets/font/Khmer Sangam MN.ttf");
    font-display: swap;
}
@font-face {
    font-family: "Khmer Sangam MN";
    src: url("./assets/font/Khmer Sangam MN.ttf");
    font-display: swap;
}
@font-face {
    font-family: "H-冬青黑体传统中文-W3";
    src: url("./assets/font/__HiraginoSansGB-W3.ttf");
    font-display: swap;
}
@font-face {
    font-family: HiraginoSansGB;
    src: url("./assets/font/__HiraginoSansGB-W3.ttf");
    font-display: swap;
}
* {
    margin: 0;
    padding: 0;
}
.flex {
    display: flex;
}
.fl-1 {
    flex: 1;
}
.fw-w {
    flex-wrap: wrap;
}
.fw-nw {
    flex-wrap: nowrap;
}
.fd-r {
    flex-direction: row;
}
.fd-c {
    flex-direction: column;
}
.fd-rr {
    flex-direction: row-reverse;
}
.ai-c {
    align-items: center;
}
.ai-fd {
    align-items: flex-end;
}
.ai-fs {
    align-items: flex-start;
}
.ai-bl {
    align-items: baseline;
}
.jc-c {
    justify-content: center;
}
.jc-sb {
    justify-content: space-between;
}
.jc-sa {
    justify-content: space-around;
}
.jc-fd {
    justify-content: flex-end;
}
.jc-fs {
    justify-content: flex-start;
}
.line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
:-moz-placeholder {
    color: #666666 !important;
    opacity: 1;
    font-weight: 400;
}

::-moz-placeholder {
    color: #666666 !important;
    opacity: 1;
    font-weight: 400;
}

input:-ms-input-placeholder {
    color: #666666 !important;
    opacity: 1;
    font-weight: 400;
}

input::-webkit-input-placeholder {
    color: #666666 !important;
    opacity: 1;
    font-weight: 400;
}

input::-moz-input-placeholder {
    color: #666666 !important;
    opacity: 1;
    font-weight: 400;
}
textarea::-webkit-input-placeholder {
    color: #666666;
}
::-webkit-scrollbar {
    width: 8px;
}
::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
}
::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #999999;
}
.van-image-preview__overlay {
    background-color: rgba(255, 255, 255, 1) !important;
}
.van-image-preview__index {
    color: rgba(0, 0, 0, 1) !important;
}
.viewer-title,
.viewer-toolbar > ul > li,
.viewer-navbar {
    display: none !important;
}
/* .viewer-toolbar > ul > li:nth-child(1),.viewer-toolbar > ul > li:nth-child(2), */
.viewer-toolbar > ul > li:nth-child(5),
.viewer-toolbar > ul > li:nth-child(7) {
    display: block !important;

    /* width: 60px;
  height: 60px;
  font-size: 50px; */
}
.viewer-container {
    background-color: #fff !important;
}
</style>
